var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sub-menu',{attrs:{"links":_vm.links,"active":_vm.active}})
}
var staticRenderFns = []

export { render, staticRenderFns }